import React from 'react';
import { FaMapMarkerAlt, FaUtensils, FaInstagram } from 'react-icons/fa';
import { LogoIcon } from '../header/Header';
import { BsTiktok } from "react-icons/bs";
import {
  Shield, Instagram, Twitter,
} from "lucide-react";

const Logo = () => (
    <div className="flex items-center gap-1 transition-all duration-300 cursor-pointer">
        <LogoIcon />
        <div className="leading-none">
            <a href="/" className="Logo-sans font-semibold text-2xl text-[#ee5219] block">Gemio</a>
            <p className="text-xs pl-0.5 -mt-2.5 text-stone-700">reservations</p>
        </div>
    </div>
);

const defaultText = `Discover dining options with gemio. Read reviews and make reservations`

const Footer = ({ description=defaultText }) => {
  return (
  <footer className="bg-gray-950 text-gray-400 pt-16 pb-8">
    <div className="max-w-6xl mx-auto px-5">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
        {/* Brand */}
        <div className="col-span-2 md:col-span-1">
          <Logo />
          <p className="text-xs leading-relaxed mt-3 text-gray-500">
            {description}
          </p>
          <div className="flex gap-3 mt-4">
            {[
              { icon: Instagram, link: "https://www.instagram.com/gemio.app/" },
              { icon: BsTiktok, link: "https://www.tiktok.com/@gemioapp" },
              { icon: Twitter, link: "https://www.instagram.com/gemio.app/" },
            ].map((s, i) => (
              <a
                key={i}
                href={s.link}
                className="w-8 h-8 rounded-lg bg-gray-800 flex items-center justify-center hover:bg-[#ee5219] transition-colors"
              >
                <s.icon size={14} />
              </a>
            ))}
          </div>
          {/* <div className="flex gap-2 mt-5">
            <a href="#" className="bg-gray-800 hover:bg-gray-700 rounded-lg px-3 py-2 text-xs font-medium transition-colors">Google Play</a>
            <a href="#" className="bg-gray-800 hover:bg-gray-700 rounded-lg px-3 py-2 text-xs font-medium transition-colors">App Store</a>
          </div> */}
        </div>

        {/* Links */}
        {[
          {
            title: "Features",
            links: [
              {
                name: "Reservation system",
                url: "/reservation",
              },
              {
                name: "Table management",
                url: "/reservation",
              },
              {
                name: "Guest messaging",
                url: "/reservation",
              },
              {
                name: "QR Digital Menus",
                url: "/dashboard",
              },
            ],
          },
          {
            title: "Company",
            links: [
              { name: "About us", url: "/about-gemio" },
              { name: "Contact us", url: "/support" },
              { name: "Privacy policy", url: "/about-gemio#privacy" },
              { name: "Terms of service", url: "/about-gemio#terms" },
            ],
          },
          {
            title: "Resources",
            links: [
              { name: "Bussiness dashboard", url: "/dashboard" },
              { name: "Help center", url: "/support" },
              { name: "Request Demo", url: "/support" },
              { name: "Claim Your listing", url: "#"},
            ],
          },
          {
            title: "Discover with Gemio",
            links: [
              { name: "New Discoveries", url: "/s?q=budget%20friendly%20restaurants&filters=budget&sortBy=budget-low" },
              { name: "Request Demo", url: "/support" },
              { name: "Claim Your listing", url: "#"},
            ],
          }
        ].map((col, i) => (
          <div key={i}>
            <h4 className="text-white font-semibold text-sm mb-3">
              {col.title}
            </h4>
            <ul className="space-y-2">
              {col.links.map((l, j) => (
                <li key={j}>
                  <a
                    href={`${l.url}`}
                    className="text-xs text-gray-500 hover:text-[#ee5219] transition-colors"
                  >
                    {l.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-gray-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-gray-600">
          © {new Date().getFullYear()} Gemio. All rights reserved. Operating in
          the Republic of Kenya.
        </p>
        <div className="flex items-center gap-1.5 text-xs text-gray-600">
          <Shield size={12} className="text-[#ee5219]" /> Gemio is trusted &
          secure
        </div>
      </div>
    </div>
  </footer>
  );
};

export default Footer;